module.exports = __webpack_public_path__ + "static/media/Illus-Congrats@2x.b0b948d0.png";